export default __webpack_public_path__ + "static/together-7d4e9b7d00595c44a2122b3fc6e3dc32.png";